module.exports = __webpack_public_path__ + "img/well-done-logo.38958cee.svg";